import React, { useState, useEffect, useRef } from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { flattenToAppURL } from '@plone/volto/helpers';
import { TextBlockView } from '@plone/volto-slate/blocks/Text';
import './viewSlide.less';

const ViewSlide = ({ item, index }) => {
  const intl = useIntl();

  return (
    <div className="review-slide" key={'slide-review-view' + index}>
      <div className="text">
        <TextBlockView data={{ value: item?.text ?? {} }} />
      </div>
      <div className="user">
        <div className="image-wrapper">
          {item.url && (
            <div className="image-wrapper">
              <img
                src={`${flattenToAppURL(item.url)}/@@images/image`}
                alt=""
                className="review-image"
                loading="lazy"
              />
            </div>
          )}
        </div>

        <div className="user-text">
          <div className="title">{item.title}</div>

          <div
            className="description"
            onKeyDown={(e) => {
              if (e.key === 'Tab') {
                updateData();
                setActiveItem(index + 1);
              }
            }}
          >
            {item.description}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewSlide;
